import { observable } from "mobx"

import {
  JobHunting as TJobHunting,
  JobHuntingInterest,
  JobHuntingStatus,
} from "~/api/student/profile/_get-types/JobHunting"

export class JobHunting {
  @observable interest: JobHuntingInterest
  @observable job_hunting_status: JobHuntingStatus

  constructor(args: TJobHunting) {
    this.interest = args.interest
    this.job_hunting_status = args.job_hunting_status
  }
}
